/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'

// 接口地址
const protocol = window.location.protocol;
switch (window.location.hostname) {
    case "pythonup.cn":
        axios.defaults.baseURL = protocol+"//www.pythonup.cn"
        break;
    case "www.pythonup.cn":
        axios.defaults.baseURL = protocol+"//www.pythonup.cn"
        break;
    default:
        axios.defaults.baseURL = protocol+"//www.pythonup.cn"
}
// 请求超时时间
axios.defaults.timeout = 60000

// 请求拦截器
axios.interceptors.request.use(
    config => {
        config.headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        }
        // add token here
        return config;
    },
    error => {
        return Promise.error(error);
    }
)
    
// 响应拦截器
axios.interceptors.response.use(
    response => {
        // some check
        return Promise.resolve(response);
    },
    // 服务器状态码不是200的情况
    error => {
        // depends on you
        return Promise.reject(error.response);
    }
)

/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    })
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    var qs = require('qs');
    params = qs.stringify(params)
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    })
}


// WEBPACK FOOTER //
// ./src/api/request.js